import { _, __ } from "../util/dom";
import { updateValidateButtonDisabledStatus } from './reportValidation';

export function allQuestions() {
    return Array.from(__(".carousel-item"));
}

export function questionSequenceId(question) {
    return _(".question-sequence", question).textContent.trim();
}

export function questionTextAreas(question) {
    return __("textarea", question);
}

export function questionCustomerResponse(question) {
    return _(".customer-response", question);
}

export function questionsRatingsInputEls() {
    return __(".rating");
}

export function questionRating(question) {
    return _(".rating", question);
}

export function questionCustomerRating(question) {
    return _(".customer-rating", question);
}

export function questionAssessorRating(question) {
    return _(".assessor-rating", question);
}

export function validateButtons() {
    return __(".validate-questions");
}

export function questionsResponseNotChangedSwitches() {
    return __('.response_not_changed_input');
}

export function questionResponseNotChangeSwitch(questionEl) {
    return _('.response_not_changed_input', questionEl);
}

export function questionTextAreasAreFilled(question) {
    const textAreas = questionTextAreas(question);
    for (let i = 0; i < textAreas.length; i++) {
        if (textAreas[i].value.trim().length === 0) {
            return false;
        }
    }
    return true;
}

export function questionCustomerResponseIsFilled(question) {
    const response = questionCustomerResponse(question);
    if (response.value && !response.textContent) {
        return response.value;
    } else {
        if (response.textContent === "" || response.textContent === "No Response") {
            return false;
        } else {
            return response.textContent;
        }
    }
}

export function questionRatingIsFilled(question) {
    const rating = questionRating(question);
    return !!rating.value;
}

export function questionIsFilled(question) {
    return (
        (questionResponseNotChangeSwitch(question) && questionResponseNotChangeSwitch(question).checked) ||
        (questionRatingIsFilled(question) &&
            questionTextAreasAreFilled(question))
    );
}

export function unfilledQuestions() {
    const questions = allQuestions();
    return questions.filter(question => {
        return !questionIsFilled(question)
    });
}

export function responsesNoChangeInit() {
    const allSwitchEls = [...questionsResponseNotChangedSwitches()]; // ... for converting nodelist to array
    const COPY_FROM_PREVIOUS_REVIEW_MESSAGE = "<Response will be copied from previous Review>";

    // will disable required inputs on load
    onLoad();
    // will bind event listener for user toggling if they want to change response
    bindListeners();

    function onLoad() {
        allSwitchEls.forEach(switchEl => {
            const parentQuestionContainerEl = switchEl.closest(".question-container");
            const shouldDisable = switchEl.checked;
            // only do it for disable true on load
            if (parentQuestionContainerEl && shouldDisable) {
                toggleResponseInputs(shouldDisable, parentQuestionContainerEl);
            }
        });
    }

    function bindListeners() {
        allSwitchEls.forEach(switchEl => {
            const parentQuestionContainerEl = switchEl.closest(".question-container");
            switchEl.addEventListener('click', event => {

                const shouldDisable = switchEl.checked;
                // throw a warning to the user if they have a response in the input and they are going to overwrite it
                if (window.authUserRole === "customer") {
                    const checkElForChange = parentQuestionContainerEl.querySelector('.check-for-on-customer-response-not-changed');
                    if (shouldDisable && checkElForChange && checkElForChange.value.length > 0 && checkElForChange.value !== COPY_FROM_PREVIOUS_REVIEW_MESSAGE) {
                        if (!confirm("Are you sure? Your current response will be overwritten.")) {
                            event.preventDefault();
                            return false;
                        }
                    }
                }
                else if (window.authUserRole === "assessor") {
                    const checkElForChange = parentQuestionContainerEl.querySelector('.check-for-on-assessor-response-not-changed');
                    if (shouldDisable && checkElForChange && checkElForChange.value.length > 0 && checkElForChange.value !== COPY_FROM_PREVIOUS_REVIEW_MESSAGE) {
                        if (!confirm("Are you sure? Your current response will be overwritten.")) {
                            event.preventDefault();
                            return false;
                        }
                    }
                }

            });
            switchEl.addEventListener('change', event => {
                const shouldDisable = switchEl.checked;
                if (parentQuestionContainerEl) {
                    toggleResponseInputs(shouldDisable, parentQuestionContainerEl);
                    // http://archives.materializecss.com/0.100.2/forms.html
                    Materialize.updateTextFields();
                }
                updateValidateButtonDisabledStatus();
            });

        });
    }

    function toggleResponseInputs(shouldDisable, parentQuestionContainerEl) {

        // check if user is customer or assessor
        if (window.authUserRole === "customer") {
            parentQuestionContainerEl.querySelectorAll('.disable-on-customer-response-not-changed').forEach(el => {
                const textValueEl = el.querySelector('.disable-on-customer-response-not-changed-text-content');
                const inputValueEl = el.querySelector('.disable-on-customer-response-not-changed-input-value');
                // const colorDivEl = el.querySelector('.disable-on-customer-response-not-changed-color-content');
                if (shouldDisable) {
                    el.classList.add('disable-pointer-events');
                    if (textValueEl) {
                        // just a generic message
                        let newValue = COPY_FROM_PREVIOUS_REVIEW_MESSAGE;
                        // get the previous review value and fill which is passes through data attribute
                        if (textValueEl.dataset.previousReviewValue) {
                            newValue = textValueEl.dataset.previousReviewValue;
                        }
                        textValueEl.textContent = newValue;
                    }
                    if (inputValueEl) {
                        // just a generic message
                        let newValue = COPY_FROM_PREVIOUS_REVIEW_MESSAGE;
                        // get the previous review value and fill which is passes through data attribute
                        if (inputValueEl.dataset.previousReviewValue) {
                            newValue = inputValueEl.dataset.previousReviewValue;
                        }
                        inputValueEl.value = newValue;
                    }
                    // if (colorDivEl) {
                    //     if (colorDivEl.dataset.previousReviewValue) {
                    //         // add a css class to the div
                    //         colorDivEl.classList.add(colorDivEl.dataset.previousReviewValue);
                    //     }
                    // }
                }
                else {
                    el.classList.remove('disable-pointer-events');
                    if (inputValueEl) {
                        inputValueEl.value = "";
                    }
                    // if (colorDivEl) {
                    //     if (colorDivEl.dataset.previousReviewValue) {
                    //         // add a css class to the div
                    //         colorDivEl.classList.remove(colorDivEl.dataset.previousReviewValue);
                    //     }
                    // }
                    if (textValueEl) {
                        textValueEl.textContent = "";
                    }
                }
            });
        } else if (window.authUserRole === "assessor") {
            parentQuestionContainerEl.querySelectorAll('.disable-on-assessor-response-not-changed').forEach(el => {
                const textValueEl = el.querySelector('.disable-on-assessor-response-not-changed-text-content');
                const inputValueEl = el.querySelector('.disable-on-assessor-response-not-changed-input-value');
                if (shouldDisable) {
                    el.classList.add('disable-pointer-events');
                    if (textValueEl) {
                        // just a generic message
                        let newValue = COPY_FROM_PREVIOUS_REVIEW_MESSAGE;
                        // get the previous review value and fill which is passes through data attribute
                        if (textValueEl.dataset.previousReviewValue) {
                            newValue = textValueEl.dataset.previousReviewValue;
                        }
                        textValueEl.textContent = newValue;
                    }
                    if (inputValueEl) {
                        // just a generic message
                        let newValue = COPY_FROM_PREVIOUS_REVIEW_MESSAGE;
                        // get the previous review value and fill which is passes through data attribute
                        if (inputValueEl.dataset.previousReviewValue) {
                            newValue = inputValueEl.dataset.previousReviewValue;
                        }
                        inputValueEl.value = newValue;
                    }
                }
                else {
                    el.classList.remove('disable-pointer-events');
                    if (inputValueEl) {
                        inputValueEl.value = "";
                    }
                    if (textValueEl) {
                        textValueEl.textContent = "";
                    }
                }
            });
        }
    }
}